"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const aGraph_1 = require("../abstract/aGraph");
class Graph extends aGraph_1.AbstractGraph {
    addNode(node) {
        /* if(!(node instanceof Vertex)){
             Errors.throwTypeError(Vertex.name,typeof(node));
             return false;
         }*/
        return super.addNode(node);
    }
}
exports.Graph = Graph;
